import { render, staticRenderFns } from "./TheReferrals.vue?vue&type=template&id=5905a482&scoped=true&"
import script from "./TheReferrals.vue?vue&type=script&lang=ts&"
export * from "./TheReferrals.vue?vue&type=script&lang=ts&"
import style0 from "./TheReferrals.vue?vue&type=style&index=0&id=5905a482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5905a482",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5905a482')) {
      api.createRecord('5905a482', component.options)
    } else {
      api.reload('5905a482', component.options)
    }
    module.hot.accept("./TheReferrals.vue?vue&type=template&id=5905a482&scoped=true&", function () {
      api.rerender('5905a482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TheReferrals.vue"
export default component.exports